
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInfo as ObiInfoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-info.js';
 
 
 

 
 export const ObiInfo = createComponent({
   react: React,
   tagName: 'obi-info',
   elementClass: ObiInfoElement,
   events: {
     
   }
  });
 
 